import { io } from 'socket.io-client';

const createSocketSlice = (set, get, ref) => {

  const now = Date.now();

  ref.connection = {
    lastSaveTime: now,
    lastErrorPopupTime: now,
    lastPreviewTime: now,
    lastConnectionAttempt: now,
  };

  return {
    socket: null,
    socketStatus: 'disconnected',

    // Функция для подключения к сокет-серверу и регистрации
    connectSocket: async () => {
      const { socket } = get();
      if (socket) {
        window.croco?.log('✖️socket.off');
        socket.off('connect');
        socket.off('reconnect');
        socket.off('reconnect_attempt');
        socket.off('reconnect_failed');
        socket.off('disconnect');
        socket.off('error');
        socket.disconnect(); // Закрываем старое соединение
      }

      const socketNames = [
        'CrocoDraw_Bot',
        'CrocoRiver_Bot',
        'CrocoZyabrBot',
        'CrocoDrawBot',
        'DoodleGatorBot',
        'CrocoBlackBot',
      ];

      const { telegram } = ref;
      const {
        gameId,
        gameParam,
        telegramUserId,
        clientId,
        initData,
        socketName,
        socketHostUrl,
        isLocalhost,
        useCDN
      } = telegram; 

      const SOCKET_SERVER_URL = socketHostUrl; 
      const FULL_SERVER_URL = useCDN ? `${SOCKET_SERVER_URL}` : `${SOCKET_SERVER_URL}:8443`; 

      // Выбираем путь для бота вместо порта
      let pathName = socketNames[socketName] || socketName;
      const PATH = isLocalhost ? null : `/${pathName}`; 

      const newSocket = io(FULL_SERVER_URL, {
        transports: ['websocket'],
        upgrade: false,   
        path: PATH, // Указываем путь для маршрутизации через Nginx
        reconnection: true,
        reconnectionAttempts: 1000,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
      });

      set({ socket: newSocket, socketStatus: 'connecting' });
      get().initHistory(newSocket);
      get().listenMafia(newSocket);

      ref.connection.lastConnectionAttempt = Date.now();

      window.croco?.log(`⏳Connecting to ${FULL_SERVER_URL}`);

      newSocket.on('connect', () => {
        window.croco?.log(`🌐Connected on address ${FULL_SERVER_URL}`);
        ref.connection.isConnectingNow = false;
        
        set((state) => ({ socketStatus: 'connected' }));

        // Отправляем событие регистрации на сервер
        const emitTime = Date.now();

        window.logPerformance?.('Authentication...');

        newSocket.emit(
          'register',
          {
            gameId,
            gameParam,
            initData,
            userId: telegramUserId,
            clientId,
            debugMode: ref.info?.user?.debugMode,
          },
          (result) => {
            get().setIsValid(result?.verified);

            window.croco?.log(`🔐Verified: ${result?.verified} | on address ${FULL_SERVER_URL}`);

            if (result?.serverTime) {
              const receiveTime = Date.now();
              const socketRTT = receiveTime - emitTime;
              ref.timeDifference = Math.floor(
                Date.now() - (result?.serverTime - socketRTT / 2)
              );
              window.logPerformance?.('Authentication completed');
              window.logPerformance?.(`Server RTT:`, `${socketRTT} ms`);
              window.logPerformance?.(`Time difference:`, `${ref.timeDifference} ms`);
            }
          }
        );
      });

      newSocket.on('reconnect', (attemptNumber) => {
        console.log(`Socket reconnected after ${attemptNumber} attempts`);
      });

      newSocket.on('reconnect_attempt', (attemptNumber) => {
        console.log(`Reconnection attempt #${attemptNumber}`);
        set({ socketStatus: 'connecting' });
      });

      newSocket.on('reconnect_failed', () => {
        console.error('Reconnection failed after all attempts');
        set({ socketStatus: 'disconnected' });
      });

      newSocket.on('disconnect', (reason) => {
        console.log('Socket disconnected:', reason);
        set({ socketStatus: 'disconnected' });
      });

      newSocket.on('error', (error) => {
        console.error('Socket error:', error);
      });


    },
  };
};

export default createSocketSlice;